export const BASE_URL = '/legal';

export const TERMS_AND_CONDITIONS_ROUTE_PATH = '/terminos-y-condiciones/';

export const PRIVACY_ROUTE_PATH = '/politicas-de-privacidad/';

export const MEMBERSHIP_POLICY_ROUTE_PATH = '/politicas-de-membresias/';

export const PAYG_POLICY_ROUTE_PATH = '/politicas-de-payg/';

export const PRIVACY_PE_ROUTE = {
  key: 'PRIVACY_PE',
  path: '',
};

export const PRIVACY_CO_ROUTE = {
  key: 'PRIVACY_CO',
  path: 'co/',
};

export const PRIVACY_CL_ROUTE = {
  key: 'PRIVACY_CL',
  path: 'cl/',
};

export const PRIVACY_MX_ROUTE = {
  key: 'PRIVACY_MX',
  path: 'mx/',
};

export const PRIVACY_ROUTES = [
  PRIVACY_PE_ROUTE,
  PRIVACY_CO_ROUTE,
  PRIVACY_CL_ROUTE,
  PRIVACY_MX_ROUTE,
];

export const MEMBERSHIP_POLICY_DUO_ROUTE = {
  key: 'MEMBERSHIP_POLICY_DUO',
  path: 'duo/',
};
export const MEMBERSHIP_POLICY_FAMILY_ROUTE = {
  key: 'MEMBERSHIP_POLICY_FAMILY',
  path: 'familiar/',
};
export const MEMBERSHIP_POLICY_PREMIUM_ROUTE = {
  key: 'MEMBERSHIP_POLICY_PREMIUM',
  path: '',
};
export const MEMBERSHIP_POLICY_STUDENT_ROUTE = {
  key: 'MEMBERSHIP_POLICY_STUDENT',
  path: 'estudiantil/',
};

export const MEMBERSHIP_POLICY_ROUTES = [
  MEMBERSHIP_POLICY_PREMIUM_ROUTE,
  MEMBERSHIP_POLICY_DUO_ROUTE,
  MEMBERSHIP_POLICY_FAMILY_ROUTE,
  MEMBERSHIP_POLICY_STUDENT_ROUTE,
];
